/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	toggleSuccessModal: () => void;
}

const PASuccessModal: React.FC<Props> = ({ toggleSuccessModal }) => {
	const { t } = useTranslation();
	return (
		<div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
			<div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
				<div className="p-10 text-center">
					<div className="w-24 h-24 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-8">
						<span className="material-symbols-outlined text-emerald-500 text-5xl"></span>
					</div>
					<h3 className="text-2xl font-black text-[#2D3E50] mb-3">
						{t(
							"postAutoclaveProcess.mediaRemoval.verificationSuccessful",
						)}
					</h3>
					<p className="text-sm text-slate-500 font-medium leading-relaxed mb-8">
						{t("postAutoclaveProcess.mediaRemoval.verificationMessage")}
					</p>
					<button
						onClick={toggleSuccessModal}
						className="w-full px-8 py-4 bg-[#2D3E50] text-white rounded-2xl text-xs font-black uppercase tracking-widest shadow-xl shadow-slate-200 hover:bg-slate-800 transition-all"
					>
						{t("postAutoclaveProcess.mediaRemoval.backToDashboard")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default PASuccessModal;
